<template>
  <div class="hold-transition">
    <Loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">{{ accion }} Programación</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item active">Operación</li>
                  <li class="breadcrumb-item active">Procesos</li>
                  <li class="breadcrumb-item active">
                    {{ accion }} Programación
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <div class="card">
              <div class="card-body justify-content-center">
                <div class="row">
                  <div class="form-group col-md-4">
                    <label for="">Fecha inicial</label>
                    <input
                      type="date"
                      class="form-control form-control-sm"
                      v-model="form.fecha_inicial"
                      @input="validaFechas()"
                      :class="
                        $v.form.fecha_inicial.$invalid
                          ? 'is-invalid'
                          : 'is-valid'
                      "
                      :disabled="estado == 2"
                    />
                  </div>
                  <div class="form-group col-md-4">
                    <label for="">Fecha final</label>
                    <input
                      type="date"
                      class="form-control form-control-sm"
                      v-model="form.fecha_final"
                      @input="validaFechas()"
                      :class="
                        $v.form.fecha_final.$invalid ? 'is-invalid' : 'is-valid'
                      "
                      :disabled="estado == 2"
                    />
                  </div>
                  <div class="form-group col-md-4">
                    <label for="">Estado</label>
                    <select
                      v-model="form.estado"
                      class="form-control form-control-sm"
                      :class="
                        $v.form.estado.$invalid ? 'is-invalid' : 'is-valid'
                      "
                      :disabled="estado == 2"
                    >
                      <option
                        v-for="estado in listasForms.estados"
                        v-bind:key="estado.numeracion"
                        v-bind:value="estado.numeracion"
                        :disabled="estado.numeracion == 2 && accion == 'Crear'"
                      >
                        {{ estado.descripcion }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="">Observación</label>
                      <textarea
                        v-model="form.observacion"
                        class="form-control form-control-sm"
                        :disabled="estado == 2"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row justify-content-center">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    @click="back()"
                  >
                    <i class="fas fa-reply"></i> Volver
                  </button>

                  <button
                    type="button"
                    class="btn btn-primary"
                    v-show="!$v.form.$invalid"
                    v-if="$store.getters.can('argentina.programaciones.save')"
                    @click="save()"
                    :disabled="estado == 2"
                  >
                    <i class="fas fa-paper-plane"></i> Guardar
                  </button>
                </div>
              </div>
            </div>

            <!-- Pestañas para seleccionar el método de cálculo -->
            <div class="card mt-3" v-if="id">
              <div class="card-header p-0">
                <ul class="nav nav-tabs" role="tablist">
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      :class="{ active: tabActiva === 'fechas' }"
                      @click="tabActiva = 'fechas'"
                      style="cursor: pointer"
                    >
                      <i class="fas fa-calendar-day mr-1"></i>
                      Por Fechas
                    </a>
                  </li>
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      :class="{ active: tabActiva === 'calendario' }"
                      @click="tabActiva = 'calendario'"
                      style="cursor: pointer"
                    >
                      <i class="fas fa-calendar-check mr-1"></i>
                      Por Calendario
                    </a>
                  </li>
                </ul>
              </div>
              <div class="card-body">
                <!-- Pestaña: Por Fechas -->
                <div v-show="tabActiva === 'fechas'">
                  <CalculoVolumenBloques
                    :fecha-inicial-maestra="form.fecha_inicial"
                    :fecha-final-maestra="form.fecha_final"
                    :programacion-id="id"
                    :estado="estado"
                    :clientes="clientes"
                    :bloques="bloques"
                    :det-programaciones-clientes="
                      form.det_programaciones_clientes || []
                    "
                  />
                </div>

                <!-- Pestaña: Por Calendario -->
                <div v-show="tabActiva === 'calendario'">
                  <CalendarioVolumen
                    :fecha-inicial-maestra="form.fecha_inicial"
                    :fecha-final-maestra="form.fecha_final"
                    :bloques="bloques"
                    :programacion-id="id"
                    :estado="estado"
                    :det-programaciones-clientes="
                      form.det_programaciones_clientes || []
                    "
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import Loading from "../../../../components/Loading";
import CalculoVolumenBloques from "./CalculoVolumenBloques";
import CalendarioVolumen from "./CalendarioVolumen";
import axios from "axios";

export default {
  name: "ProgramacionForm",
  components: {
    Loading,
    CalculoVolumenBloques,
    CalendarioVolumen,
  },
  data() {
    return {
      cargando: false,
      accion: "",
      metodo: "",
      estado: null,
      id: null,
      listasForms: {
        estados: [],
      },
      form: {
        user_id: null,
        fecha_inicial: "",
        fecha_final: "",
        estado: 1,
        observacion: "",
        det_programaciones_clientes: [],
      },
      clientes: [],
      bloques: [],
      tabActiva: "fechas", // 'fechas' o 'calendario'
    };
  },
  computed: {
    esEstadoDefinitivo() {
      return this.form.estado == 2 || this.form.estado === "2";
    },
  },
  validations: {
    form: {
      fecha_inicial: {
        required,
      },
      fecha_final: {
        required,
      },
      estado: {
        required,
      },
    },
  },
  methods: {
    init() {
      this.accion = this.$route.params.accion;
      this.id = this.$route.params.id;
      if (this.accion == "Editar") {
        this.metodo = "PUT";
        this.show();
      } else {
        this.metodo = "POST";
      }
    },

    getEstados() {
      axios.get("/api/lista/28").then((response) => {
        this.listasForms.estados = response.data;
      });
    },

    validaFechas() {
      if (this.form.fecha_inicial && this.form.fecha_final) {
        const fecha_menor = new Date(this.form.fecha_inicial);
        const fecha_mayor = new Date(this.form.fecha_final);
        // Se valida que la fecha inicial sea menor que la fecha final
        if (fecha_menor > fecha_mayor) {
          this.form.fecha_final = null;
          this.$swal({
            icon: "error",
            title: `La fecha inicial no puede ser mayor a la fecha final...`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        }
      }
    },

    save() {
      if (!this.$v.form.$invalid) {
        this.cargando = true;
        axios({
          method: this.metodo,
          url: "/api/argentina/programaciones",
          data: this.form,
        })
          .then((response) => {
            this.cargando = false;
            this.$route.params.accion = "Editar";
            this.$route.params.id = response.data.id;
            this.init();
            this.$swal({
              icon: "success",
              title: "La programación se guardó exitosamente",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          })
          .catch((error) => {
            this.cargando = false;
            this.$swal({
              icon: "error",
              title: "Ocurrió un error al guardar la programación",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    show() {
      this.cargando = true;
      axios
        .get("/api/argentina/programaciones/show/" + this.id)
        .then((response) => {
          this.cargando = false;
          this.estado = response.data.estado;
          this.form = response.data;
          // Asegurar que det_programaciones_clientes existe y es un array
          if (!this.form.det_programaciones_clientes) {
            this.$set(this.form, "det_programaciones_clientes", []);
          }
        })
        .catch((error) => {
          this.cargando = false;
          this.$swal({
            icon: "error",
            title: "Ocurrió un error al mostrar la programación",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    async getBloques() {
      try {
        const response = await axios.get("/api/argentina/bloques/lista", {
          params: { pais_id: 3 },
        });

        if (!response.data) {
          this.bloques = [];
          return;
        }

        // response.data puede ser array o objeto con data
        const listaBloques = Array.isArray(response.data)
          ? response.data
          : response.data.data || response.data.bloques || [];

        this.bloques = listaBloques;
      } catch (error) {
        console.error("Error obteniendo bloques:", error);
        this.bloques = [];
      }
    },

    async getClientes() {
      try {
        const response = await axios.get("/api/argentina/clientes/lista", {
          params: { pais_id: 3 },
        });
        if (!response.data) {
          this.clientes = [];
          return;
        }
        this.clientes = response.data;
      } catch (error) {
        console.error("Error obteniendo clientes:", error);
      }
    },

    back() {
      return this.$router.replace("/Argentina/Operacion/Programaciones");
    },
  },

  beforeMount() {
    this.getEstados();
  },

  mounted() {
    this.init();
    this.getBloques();
    this.getClientes();
  },
};
</script>
